<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >
      <div *ngIf="selected!=null">
        <div class="sidebar header-spacing"></div>
        <ngx-form-text title="Name" [(value)]="selected.name"></ngx-form-text>
        <ngx-form-area title="Description" [(value)]="selected.description"></ngx-form-area>
        <br>

        <div class="sidebar header-spacing"></div>
        <div class="sidebar header">
          <div class="row">
            <div class="col-md-12">
              <h1> {{selected.name}}</h1>
            </div>
          </div>
        </div>
        <div class="sidebar footer">
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <button class="btn btn-default btn-lg" (click)="cancel(selected)">Cancel</button>
              <button class="btn btn-primary btn-lg" (click)="save(selected)">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Regions</h1>
      <hr>
      <button class="btn btn-primary btn-sm pull-right" (click)="create()">+</button>
      <table class="table table-hover">
        <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Last Updated</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of regions| async | paginate: { itemsPerPage: 14, currentPage: p }"
            [ngClass]="{'table-active': item === selected}"
            (click)="select(item)">
          <td>{{item.name}}</td>
          <td>{{$any(item).updatedAt  | date: 'dd. MM. yyyy'}}</td>
          <td>
            <button class="btn btn-default btn-sm" (click)="toggleSidebar(item)"><i class="ion-edit"></i></button>
            <!--<div class="dropdown" ngbDropdown>
              <button class="btn btn-default btn-sm btn-dropdown noarrow" type="button" ngbDropdownToggle>
                <i class="ion-more"></i>
              </button>
              <ul class="nrk-dropdown-menu" ngbDropdownMenu>
                <li class="dropdown-item" (click)="toggleSidebar(item)"><i class="ion-edit"></i>&nbsp;Bearbeiten</li>
                <li class="dropdown-item" (click)="toggleActive(item)"><i class="ion-flag"></i>&nbsp;{{ !item.active?"Aktiv":"Inaktiv"}} setzen</li>
              </ul>
            </div>-->
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls (pageChange)="p = $event"></pagination-controls>
    </ngx-page-container>
  </div>
</ng-sidebar-container>
